import { useEffect, useState } from "react"

function ProductReviews({ productId }){

const [reviews,setReviews] = useState([])

useEffect(()=>{

if(!productId) return

fetch(`/wp-json/wc/store/products/reviews?product_id=${productId}`)
.then(res => res.json())
.then(data => {

if(Array.isArray(data)){
setReviews(data)
}else{
setReviews([])
}

})

},[productId])

return(

<div className="reviewSection">

<h2>Customer Reviews</h2>

{reviews.length === 0 && (
<p>No reviews yet.</p>
)}

{reviews.map(r => (

<div key={r.id} className="reviewCard">

<h4>{r.reviewer}</h4>

<p>⭐ {r.rating}</p>

<p dangerouslySetInnerHTML={{__html:r.review}} />

</div>

))}

</div>

)

}

export default ProductReviews